import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, RadioGroup } from '@systemeio/ui';
import { useUserPricePlans } from 'modules/digital-product/price-plans/hooks/use-user-price-plans';
import React, { useEffect, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PricePlanRemoveTypeEnum } from '../enums/price-plan-remove-type-enum';
import { getPricePlanRemoveTypeData } from '../utils/price-plans-utils';
import { PricePlanId } from '@systemeio/types';
interface RemovePricePlanConfirmationProps {
  pricePlanId: PricePlanId | null;
  currency: CurrencyEnum;
  onRemove: (removeType: PricePlanRemoveTypeEnum) => Promise<void>;
  afterLeave: () => void;
}
function RemovePricePlanConfirmation(t0) {
  const $ = _c(34);
  const {
    pricePlanId,
    currency,
    onRemove,
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getPricePlanRemoveTypeData(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pricePlanRemoveTypeData = t1;
  const [removeType, setRemoveType] = useState(pricePlanRemoveTypeData[0].id);
  const [opened, setOpened] = useState(false);
  const {
    userPricePlans
  } = useUserPricePlans(currency);
  let t2;
  let t3;
  if ($[2] !== pricePlanId) {
    t2 = () => {
      setOpened(!!pricePlanId);
    };
    t3 = [pricePlanId];
    $[2] = pricePlanId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let T0;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[5] !== afterLeave || $[6] !== onRemove || $[7] !== opened || $[8] !== pricePlanId || $[9] !== removeType || $[10] !== t || $[11] !== userPricePlans) {
    const pricePlan_0 = userPricePlans?.find(pricePlan => pricePlan.id === pricePlanId);
    T0 = Confirmation;
    t4 = opened;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => {
        setOpened(false);
      };
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t6 = afterLeave;
    if ($[19] !== onRemove || $[20] !== removeType) {
      t7 = () => onRemove(removeType);
      $[19] = onRemove;
      $[20] = removeType;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t8 = t("dashboard.funnel.configuration.common.price_plan.remove_confirmation", {
      pricePlanName: pricePlan_0?.innerName
    });
    $[5] = afterLeave;
    $[6] = onRemove;
    $[7] = opened;
    $[8] = pricePlanId;
    $[9] = removeType;
    $[10] = t;
    $[11] = userPricePlans;
    $[12] = T0;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    T0 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = data => setRemoveType(data);
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== pricePlanRemoveTypeData || $[24] !== removeType) {
    t10 = <div className="flex justify-start"><RadioGroup options={pricePlanRemoveTypeData} selected={removeType} onChange={t9} optionsWrapperClassName="flex-col !items-start" /></div>;
    $[23] = pricePlanRemoveTypeData;
    $[24] = removeType;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== T0 || $[27] !== t10 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t11 = <T0 opened={t4} onClose={t5} afterLeave={t6} onConfirm={t7} confirmationText={t8} confirmationContent={t10} />;
    $[26] = T0;
    $[27] = t10;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}
export default RemovePricePlanConfirmation;